export const getWordpressAuthResponse = state => {
  return state.integrations.wordpressAuthResponse;
};
export const getHasWordpressAuthSucceeded = state => {
  return state.integrations.wordpressAuthSucceeded;
};
export const getWordpressValidPermissions = state => {
  return state.integrations.wordpressValidPermissions;
};
export const getIsWordPressAuthFinished = state => {
  return state.integrations.wordpressAuthFinished;
};